import { FilterFieldType, IFilter } from './types'

export const AGENT_MEMORY_SCOPES = ['global', 'user'] as const
export const AGENT_MEMORY_SOURCE_TYPES = [
  'user_taught',
  'derived_from_doc',
  'agent_extracted',
  'seeded',
  'unknown',
] as const

/**
 * Shared by both memories and skills admin pages. The `type` column isn't a
 * user filter — it's preset server-side by the route (memories vs skills) so
 * the two lists never cross-pollinate.
 *
 * Column order in the config drives column order in the table.
 */
export const ATLAS_MEMORIES_FILTERS_CONFIG = [
  {
    field: 'key',
    dbField: 'key',
    alias: 'memory',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Key',
  },
  {
    field: 'category',
    dbField: 'category',
    alias: 'memory',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Category',
  },
  {
    field: 'scope',
    dbField: 'scope',
    alias: 'memory',
    type: FilterFieldType.List,
    isSortable: true,
    isMultiple: true,
    title: 'Scope',
    options: AGENT_MEMORY_SCOPES.map((value) => ({ value, label: value })),
  },
  {
    field: 'sourceType',
    dbField: 'source_type',
    alias: 'memory',
    type: FilterFieldType.List,
    isSortable: true,
    isMultiple: true,
    title: 'Source',
    options: AGENT_MEMORY_SOURCE_TYPES.map((value) => ({ value, label: value })),
  },
  {
    // Display-only column — tag chips render in the body; no filter UI.
    field: 'tags',
    type: FilterFieldType.Text,
    title: 'Tags',
    excludeFilter: true,
  },
  {
    field: 'createdAt',
    dbField: 'created_at',
    alias: 'memory',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Created',
  },
  {
    field: 'updatedAt',
    dbField: 'updated_at',
    alias: 'memory',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Last edited',
  },
] as const satisfies IFilter[]
